import { render, staticRenderFns } from "./AccountNameChip.vue?vue&type=template&id=2026b2f2&scoped=true"
import script from "./AccountNameChip.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountNameChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountNameChip.vue?vue&type=style&index=0&id=2026b2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026b2f2",
  null
  
)

export default component.exports